import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class TWorkflowPriorityDM extends Data {
	public static className = 'TWorkflowPriorityDM'
	public static primaryKey = 'Id'
	public static systemFields = [
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	Name?: string
	PriorityId?: number
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	SQLSequenceOrderCalc?: number
	PriorityImgCalc?: string
}